var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMain2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "svgWidth",
    width: 888,
    height: 712,
    viewBox: "0 0 888 712",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M609.841 46.4623C226.262 -21.1731 -467.883 339.305 631.348 379.443C1730.58 419.581 834.314 832.175 46.4619 606.91",
    stroke: "white",
    strokeWidth: 75
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMain2);
export default __webpack_public_path__ + "static/media/main2.0de43f1b182782b5b86755693244c901.svg";
export { ForwardRef as ReactComponent };